import { render, staticRenderFns } from "./DsForo.vue?vue&type=template&id=ea06efd0&scoped=true"
import script from "./DsForo.vue?vue&type=script&lang=js"
export * from "./DsForo.vue?vue&type=script&lang=js"
import style0 from "./DsForo.vue?vue&type=style&index=0&id=ea06efd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea06efd0",
  null
  
)

export default component.exports